import { api } from "./client";

export const accessTokenApi = {
	get: () => api.get<{ token: string | null }>("/me/access-token"),
	create: () => api.post<{ token: string }>("/me/access-token"),
	revoke: () => api.del<{ ok: boolean }>("/me/access-token"),
	exchange: (token: string) =>
		api.post<{
			user: {
				id: string;
				email: string;
				name: string;
				image: string | null;
				emailVerified: boolean;
				isAdmin: boolean;
			};
		}>("/auth/access", { token }),
};
